// @ts-ignore
/* eslint-disable */
///////////////////////////////////////////////////////////////////////
//                                                                   //
// this file is autogenerated by service-generate                    //
// do not edit this file manually                                    //
//                                                                   //
///////////////////////////////////////////////////////////////////////
/// <reference path = "api-auto.d.ts" />
import request from '@/utils/ajax'

/**
 * Signup by user-password
 */
export async function UserPasswordControllerSignup(
  params: Definitions.PasswdSignupDto,
): Promise<{
  error: string
  data: Paths.UserPasswordControllerSignup.Responses
}> {
  // /v1/auth/passwd/signup
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/auth/passwd/signup`, {
    ..._params,
  })
}

/**
 * Signin by user-password
 */
export async function UserPasswordControllerSignin(
  params: Definitions.PasswdSigninDto,
): Promise<{
  error: string
  data: Paths.UserPasswordControllerSignin.Responses
}> {
  // /v1/auth/passwd/signin
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/auth/passwd/signin`, {
    ..._params,
  })
}

/**
 * Reset password
 */
export async function UserPasswordControllerReset(
  params: Definitions.PasswdResetDto,
): Promise<{
  error: string
  data: Paths.UserPasswordControllerReset.Responses
}> {
  // /v1/auth/passwd/reset
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/auth/passwd/reset`, {
    ..._params,
  })
}

/**
 * Check if user-password is set
 */
export async function UserPasswordControllerCheck(
  params: Definitions.PasswdCheckDto,
): Promise<{
  error: string
  data: Paths.UserPasswordControllerCheck.Responses
}> {
  // /v1/auth/passwd/check
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/auth/passwd/check`, {
    ..._params,
  })
}

/**
 * Auth providers
 */
export async function AuthenticationControllerGetProviders(
  params: Paths.AuthenticationControllerGetProviders.BodyParameters,
): Promise<{
  error: string
  data: Paths.AuthenticationControllerGetProviders.Responses
}> {
  // /v1/auth/providers
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/auth/providers`, {
    params: _params,
  })
}

/**
 * Get user token by PAT
 */
export async function AuthenticationControllerPat2token(
  params: Definitions.Pat2TokenDto,
): Promise<{
  error: string
  data: Paths.AuthenticationControllerPat2token.Responses
}> {
  // /v1/auth/pat2token
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/auth/pat2token`, {
    ..._params,
  })
}

/**
 * Send email verify code
 */
export async function EmailControllerSendCode(
  params: Definitions.SendEmailCodeDto,
): Promise<{
  error: string
  data: Paths.EmailControllerSendCode.Responses
}> {
  // /v1/auth/email/code
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/auth/email/code`, {
    ..._params,
  })
}

/**
 * Signin by email and verify code
 */
export async function EmailControllerSignin(
  params: Definitions.EmailSigninDto,
): Promise<{
  error: string
  data: Paths.EmailControllerSignin.Responses
}> {
  // /v1/auth/email/signin
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/auth/email/signin`, {
    ..._params,
  })
}
